<div class="modulos-destaque">
      <div *ngFor="let m of modulos;let last=lats;" [ngSwitch]="m.tag">
            <div *ngSwitchCase="'produto-destaque-categoria'">   
                  <modulo-produto-categoria-destaque [data]="m"></modulo-produto-categoria-destaque>
            </div>
            <div *ngSwitchCase="'produto-busca'">   
                  <modulo-produto-busca [data]="m"></modulo-produto-busca>
            </div>
            <div *ngSwitchCase="'newsletter'">   
                  <modulo-newsletter [data]="m"></modulo-newsletter>
            </div>
            <div *ngSwitchCase="'banner'">   
                  <modulo-banner [data]="m"></modulo-banner>
            </div>
            <div *ngSwitchCase="'eventos'">   
                  <modulo-eventos [data]="m"></modulo-eventos>
            </div>
      </div>
</div>       
